export const APP_TITLE           = 'OpenSource';
export const DEFAULT_DESCRITPION = `When we learn something, we write a blog post; when we polish a new development approach,
                                      we do a workshop for teams like ours; when we create a new framework, we open source it.`;
export const CAPTCHA_KEY = '6LcWjXYdAAAAAD7Lggc1TajsTeBrG5lXV0paaNOJ';
